import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import competencies from 'modules/competencies/store/collections/competencies'
import competencyOptions from 'modules/competencies/store/collections/competencyOptions'
import levels from 'modules/job_catalog/store/collections/levels'
import roles from 'modules/job_catalog/store/collections/roles'

interface Values {
  loading: boolean
}

const Context = React.createContext<Values>({ loading: false })

export const CompetenciesProvider = ({
  children,
}: React.PropsWithChildren<Record<string, unknown>>) => {
  const { loading } = useAsyncData(
    () =>
      Promise.all([competencies.fetch(), competencyOptions.fetch(), levels.fetch(), roles.fetch()]),
    []
  )

  const values: Values = {
    loading,
  }

  return <Context.Provider value={values}>{children}</Context.Provider>
}

export const useCompetencies = (): Values => {
  const values = React.useContext(Context)

  if (!values) throw new Error('useCompetencies must be used within a CompetenciesProvider')

  return values
}
